import { i18nFilter } from "app/filters/i18nFilter";
import dayjs from "dayjs";
import type { FC } from "react";
import styled from "styled-components";
import { TrendsBar } from "pro-features/components/TrendsBar/src/TrendsBar";

import { numberFilter } from "app/filters/numberFilter";

interface IWebsiteAnalysisTrendsBarProps {
    data: Array<{ Key: string; Value: number }>;
    barsLimit?: number;
    inverted?: boolean;
    rowName: string;
}

const dateFormat = (date) => dayjs(date).format("MMM, YYYY");
const Container = styled.div`
    height: 20px;
`;

export const WebsiteAnalysisTrendsBar: FC<IWebsiteAnalysisTrendsBarProps> = ({
    data,
    barsLimit,
    inverted,
    rowName,
}) => {
    const dataWithTooltips = data.map((item) => {
        return {
            value: item.Value,
            tooltip: i18nFilter()(`wa.ao.ranks.trend.tooltip.${rowName}`, {
                date: dateFormat(item.Key),
                value: numberFilter()(item.Value),
            }),
        };
    });
    return (
        <Container>
            <TrendsBar
                values={dataWithTooltips}
                barsLimit={barsLimit}
                inverted={inverted}
            />
        </Container>
    );
};

